import React from 'react'
import NavBarUserCartButton from './NavBarUserCartButton'
import NavBarMultiCartButton from './NavBarMultiCartButton'
import { useSharedCartFeatureFlag } from 'hooks/useSharedCartFeatureFlag'

interface Props {
  className?: string
  allowCartPreview?: boolean
}

function NavBarCartButton(props: Props) {
  const isSharedCartsEnabled = useSharedCartFeatureFlag()

  if (isSharedCartsEnabled) {
    return <NavBarMultiCartButton {...props} />
  }

  return <NavBarUserCartButton {...props} />
}

export default React.memo(NavBarCartButton)
